// A business token does not replace the already-connected RTC identity.
export function createMeetingAccountAccess({ session, verify, isConnected, canResumeConnection = () => true, onChange = () => {}, onState = () => {} }) {
  let boundSession
  let boundIdentity = ''
  let verifiedSession
  let state = { status: 'idle' }
  let stopped = false
  let started = false
  let run = 0
  let unsubscribe
  let pending
  const emit = next => { state = next; onState(next) }
  async function check() {
    const expected = session.snapshot()
    const attempt = ++run
    verifiedSession = undefined
    emit({ status: expected.token ? 'checking' : 'anonymous' })
    if (!expected.token) return false
    try {
      const result = await verify()
      if (stopped || attempt !== run || !session.isCurrent(expected)) return false
      if (!result.allowed) { emit({ status: 'denied', accountName: result.accountName }); return false }
      const sameIdentity = boundIdentity && result.identity && boundIdentity === result.identity
      if (boundSession && isConnected() && (!canResumeConnection() || (boundSession.token !== expected.token && !sameIdentity))) {
        emit({ status: 'changed', accountName: result.accountName })
        return false
      }
      boundSession = expected
      boundIdentity = result.identity || ''
      verifiedSession = expected
      emit({ status: 'ready', accountName: result.accountName, result })
      return true
    } catch {
      if (!stopped && attempt === run && session.isCurrent(expected)) {
        emit({ status: expected.token ? 'error' : 'anonymous' })
      }
      return false
    }
  }
  function start() {
    if (started) return pending
    started = true
    unsubscribe = session.subscribe(() => {
      if (stopped) return
      verifiedSession = undefined
      // Synchronous invalidation precedes any asynchronous permission request.
      try { onChange() } catch { /* Permission invalidation must survive UI cleanup failures. */ }
      pending = check()
    })
    pending = check()
    return pending
  }
  return {
    start, retry: () => (pending = check()),
    allowed: () => started && !stopped && session.isCurrent(verifiedSession) && state.status === 'ready',
    active: () => started && !stopped,
    dispose: () => { stopped = true; run += 1; unsubscribe?.() },
  }
}
